import React, { ReactNode, useEffect, useRef, useState } from "react";
import styles from "./Modal.module.scss";
import CLOSE_ICON from "../../assets/Icons/nav/x.png";

interface props {
  onClose?: () => void;
  onSave?: () => void;
  saveTitle?: string;
  cancelTitle?: string;
  children: ReactNode;
  showButtons?: boolean;
  onOkClick?: () => void;
  className?: string;
  scroll?: string;
  bgPopup?: string;
  showOK?: boolean;
  isOpen?: boolean;
  customWidthClass?: string;
}

const Modal = ({
  onClose,
  scroll,
  onSave,
  children,
  saveTitle = "Yes",
  cancelTitle = "Cancel",
  showButtons = true,
  onOkClick,
  className,
  bgPopup,
  showOK = true,
  isOpen = true,
  customWidthClass = "",
}: props) => {
  const drawerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isOpen) return;

    let scrollY = 0;

    const preventScroll = (e: TouchEvent) => {
      if (drawerRef.current && !drawerRef.current.contains(e.target as Node)) {
        e.preventDefault();
      }
    };

    const header = document.getElementById("header");

    if (isOpen) {
      scrollY = window.scrollY;

      // Lock body scroll
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";

      // iOS Safari specific scroll lock
      document.addEventListener("touchmove", preventScroll, { passive: false });
      if (header) header.style.zIndex = "0";
    } else {
      const top = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.width = "";

      window.scrollTo(0, parseInt(top || "0") * -1);
      document.removeEventListener("touchmove", preventScroll);
      if (header) header.style.zIndex = "50";
    }

    return () => {
      const top = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.width = "";

      window.scrollTo(0, parseInt(top || "0") * -1);
      document.removeEventListener("touchmove", preventScroll);
      if (header) header.style.zIndex = "50";
    };
  }, [isOpen]);

  // 📱 iOS Safari address bar hide trick
  useEffect(() => {
    if (
      isOpen &&
      typeof window !== "undefined" &&
      /iPhone|iPad|iPod/i.test(navigator.userAgent)
    ) {
      window.scrollTo(0, 1); // Trigger initial scroll
      setTimeout(() => window.scrollTo(0, 0), 100); // Snap back
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      ref={drawerRef}
      className={`${styles.popupOuter} ${className} backdrop-blur-xl z-[200]  `}
    >
      <div className={styles.popupOverlay}></div>
      <div className={`${customWidthClass} ${styles.popupContent}`}>
        <div
          className={`${styles.sideNav} ${styles.animateNav} ${
            bgPopup ? bgPopup : "bg-button-gray"
          } pb-6`}
        >
          {/* <div className='flex justify-end w-full px-3 mt-2'>
            <img src={CLOSE_ICON} alt='close' className='size-5 cursor-pointer' onClick={onClose}/>
          </div> */}
          <div className={`px-8 py-7 text-py-text-primary text-2xl ${scroll}`}>
            {children}
          </div>
          {showButtons ? (
            <div className="flex gap-8">
              <button
                className="bg-py-bg-secondary text-py-text-primary min-w-20 h-8 rounded-md px-2"
                onClick={onClose}
              >
                {cancelTitle}
              </button>
              <button
                className="bg-py-bg-primary text-py-text-secondary min-w-20 h-8 rounded-md px-2"
                onClick={onSave}
              >
                {saveTitle}
              </button>
            </div>
          ) : (
            showOK && (
              <button
                className="bg-py-bg-primary text-py-text-secondary min-w-20 h-8 rounded-md px-2"
                onClick={onOkClick}
              >
                Ok
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
